export { DesktopDisplayControl } from "./displayControl.desktop";
export { MobileDisplayControl } from "./displayControl.mobile";
